import React from 'react';

const FormContainer = ({ children, className }) => {
    return (
        <div className={`d-flex flex-wrap ${className || ''}`}>{children || ''}</div>
    );
};

export default FormContainer;